const _static={
    server:"https://server.devdailychallenge.com"
}

export default _static;